import { defineMessages } from "react-intl";
import { Gender } from "../../contract/pam.js";
const localizedGender = defineMessages({
  [Gender.Female]: {
    id: "genderFemale",
    defaultMessage: "Female"
  },
  [Gender.Male]: {
    id: "genderMale",
    defaultMessage: "Male"
  },
  [Gender.Undefined]: {
    id: "genderUndefined",
    defaultMessage: "Undefined"
  }
});
export {
  localizedGender
};
//# sourceMappingURL=gender.js.map
